import React from 'react';
import PropTypes from 'prop-types';
import CustomButton from '../custom_button/customButton';
import './LineWithButtons.css';

function LineWithButtons({ tabs, buttons,rightSide, basicStyle = 'line-with-buttons-without-background-color' }) {
    const renderComponent = (item, index) => {
        const { component: Component, props } = item;

        if (!Component) {
            console.error(`Invalid component at index ${index}:`, item);
            return null; // Pomiń element, jeśli nie ma komponentu
        }

        return <Component key={index} {...props} />;
    };

    return (
    <div className={basicStyle}>
      {/* Lewa strona - zakładki */}
      <div className="tabs">
        {tabs.map((tab, index) => {
          if (React.isValidElement(tab)) {
            // Jeśli element jest poprawnym komponentem React, renderuj go bez zmian
            return React.cloneElement(tab, { key: index });
          } else if (typeof tab === 'object' && tab.icon && tab.name) {
            // Jeśli element jest obiektem zgodnym z CustomButton, renderuj CustomButton
            return (
              <CustomButton
                key={index}
                icon={tab.icon}
                name={tab.name}
                baseClass={tab.baseClass}
                hoverClass={tab.hoverClass}
                borders={tab.borders}
                activeClass={tab.activeClass}
                onClick={tab.onClick}
              />
            );
          } else {
            console.error(`Invalid tab element at index ${index}:`, tab);
            return null; // Pomiń niepoprawny element
          }
        })}
      </div>

        <div className="right-side">
            {rightSide.map((item, index) => renderComponent(item, index))}
        </div>

      {/* Prawa strona - przyciski */}
      <div className="buttons">
        {buttons.map((button, index) => {
          if (React.isValidElement(button)) {
            // Jeśli element jest poprawnym komponentem React, renderuj go bez zmian
            return React.cloneElement(button, { key: index });
          } else if (typeof button === 'object' && button.icon && button.name) {
            // Jeśli element jest obiektem zgodnym z CustomButton, renderuj CustomButton
            return (
              <CustomButton
                key={index}
                icon={button.icon}
                name={button.name}
                baseClass={button.baseClass}
                hoverClass={button.hoverClass}
                borders={button.borders}
                activeClass={button.activeClass}
                onClick={button.onClick}
              />
            );
          } else {
            console.error(`Invalid button element at index ${index}:`, button);
            return null; // Pomiń niepoprawny element
          }
        })}
      </div>
    </div>
  );
}

LineWithButtons.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.node, // Dowolny komponent React
      PropTypes.shape({
        icon: PropTypes.elementType,
        name: PropTypes.string.isRequired,
        baseClass: PropTypes.string,
        hoverClass: PropTypes.string.isRequired,
        borders: PropTypes.string,
        activeClass: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
      }),
    ])
  ).isRequired,
    rightSide: PropTypes.arrayOf(
        PropTypes.shape({
            component: PropTypes.elementType.isRequired, // Komponent do wyrenderowania
            props: PropTypes.object, // Właściwości przekazywane do komponentu
        })
    ).isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.node, // Dowolny komponent React
      PropTypes.shape({
        icon: PropTypes.elementType,
        name: PropTypes.string.isRequired,
        baseClass: PropTypes.string,
        hoverClass: PropTypes.string.isRequired,
        borders: PropTypes.string,
        activeClass: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
      }),
    ])
  ).isRequired,
  basicStyle: PropTypes.string, // Klasa podstawowego wyglądu dla głównego elementu
};

LineWithButtons.defaultProps = {
  basicStyle: 'line-with-buttons', // Domyślna wartość dla basicStyle
};

export default LineWithButtons;